import { Box, styled } from '@arpeggi/ui'
import { FC } from 'react'
import { gray3 } from '../../../../../../__legacy__/components/platform/color'
import { ColumnLabel } from '../../upload-sound-modal/MintSoundModalContent'

const SplitDetailsTableHeader: FC<{ showSplits?: boolean }> = ({ showSplits = true }) => {
  return (
    <Box row css={{ backgroundColor: gray3, borderRadius: '8px 8px 0px 0px' }}>
      <Box row css={{ flex: 2 }} alignCenter>
        <ColumnLabel>Sound</ColumnLabel>
      </Box>
      <Box row css={{ flex: 1 }} alignCenter>
        <ColumnLabel>Artist</ColumnLabel>
      </Box>
      <Box row css={{ flex: 1 }} alignCenter>
        <ColumnLabel>Address</ColumnLabel>
      </Box>
      {showSplits && (
        <Box row css={{ flex: 1.5 }} alignCenter justifyCenter>
          <ColumnLabel>% Split</ColumnLabel>
        </Box>
      )}
    </Box>
  )
}

const Column = styled('div', {
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
})

const ColumnContent = styled('div', {
  padding: '12px'
})

export const SplitsTable = {
  Header: SplitDetailsTableHeader,
  Column,
  ColumnContent
}
